import { BusinessType } from "@tfg/db/browser"
import { Loader, Select } from "@tfg/ui"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { useUpdateOrganizationMutation } from "./hooks"

interface Props {
  organization: AdminResponses.Organization
}

export const ChangeBusinessType = ({ organization }: Props) => {
  const { mutate: updateOrganization, isPending: isLoading } =
    useUpdateOrganizationMutation(organization.id.toString())

  return isLoading ? (
    <Loader />
  ) : (
    <Select
      data={Object.keys(BusinessType).map((key) => ({
        label: key,
        value: key,
      }))}
      placeholder="Business type"
      value={organization.businessType ?? null}
      onChange={(newBusinessType: string | null) =>
        newBusinessType &&
        updateOrganization({ businessType: newBusinessType as BusinessType })
      }
      w={300}
    />
  )
}
